import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { SeguridadService, ParametroSistemaService } from '../../shared/services';
import { RegisterUsuarioDto } from '../../shared/model';

@Component({
  selector: 'app-dialogRegistroUsuario',
  templateUrl: 'dialogRegistroUsuario.component.html'
})

export class DialogRegistroUsuarioComponent implements OnInit {
  @ViewChild('input') input: ElementRef;
  formUserGroup: FormGroup;
  formAdminGroup: FormGroup;
  private entity: RegisterUsuarioDto;
  hide: boolean = true;
  esUsuarioAdmin: boolean = false;
  esUsuarioPropietario: boolean = false;
  buttonEnabled: boolean = true;
  allowUserRegistration: boolean = false;
  mustWaitUserConfirm: boolean = false;
  newConsorcio: string;
  consorcios: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogRegistroUsuarioComponent>,
    private formBuilder: FormBuilder, 
    private sharedFunctions: SharedFunctions,
    private seguridadService: SeguridadService,
    private parametroSistemaService: ParametroSistemaService
  ) {
  }

  ngOnInit(): void {
    this.buildUserForm();
    this.buildAdminForm();

    this.parametroSistemaService.getAnonymousCode("PermitirAltaUsuarios").subscribe(response => {
      if (response && response.Success) {
        this.allowUserRegistration = response.Result?.Valor ? (response.Result?.Valor?.toLowerCase() == "true" || response.Result?.Valor?.toLowerCase() == "1") : false;
      }
    }, 
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.parametroSistemaService.getAnonymousCode("ConfirmarActivacionUsuariosNuevos").subscribe(response => {
      if (response && response.Success) {
        this.mustWaitUserConfirm = response.Result?.Valor ? (response.Result?.Valor?.toLowerCase() == "true" || response.Result?.Valor?.toLowerCase() == "1") : false;
      }
    }, 
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildAdminForm() {
    this.formAdminGroup = this.formBuilder.group({
      'RazonSocial': [null, [Validators.required, Validators.maxLength(200)]],
      'NombreContacto': [null, [Validators.required, Validators.maxLength(150)]],
      'Cuit': [null],
      'Mail': [null, [Validators.required, Validators.maxLength(255), Validators.email]],
      'Movil': [null, Validators.maxLength(100)],
      'CantidadConsorcios': [null, Validators.required],
      'Consorcios': [null]
    });
  }

  buildUserForm() {
    this.formUserGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, Validators.maxLength(150)],
      'NroDocumento': [null, Validators.maxLength(100)],
      'Mail': [null, [Validators.required, Validators.maxLength(255), Validators.email]],
      'Movil': [null, Validators.maxLength(100)],
      'Login': [null, [Validators.required, Validators.maxLength(100)]],
      'Clave': [null, [Validators.required, Validators.maxLength(100)]],
      'ConfirmClave': [null, [Validators.required, Validators.maxLength(100)]]
    });
  }

  getAdminErrorRazonSocial() {
    var v = this.formAdminGroup.get('RazonSocial');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getAdminErrorNombreContacto() {
    var v = this.formAdminGroup.get('NombreContacto');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
          
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }
 
  getAdminErrorMail() {
    var v = this.formAdminGroup.get('Mail');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getAdminErrorCantidadConsorcios() {
    return this.formAdminGroup.get('CantidadConsorcios')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNombre() {
    var v = this.formUserGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido() {
    var v = this.formUserGroup.get('Apellido');
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorMail() {
    var v = this.formUserGroup.get('Mail');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorLogin() {
    var v = this.formUserGroup.get('Login');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorClave() {
    var v = this.formUserGroup.get('Clave');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorConfirmClave() {
    var v = this.formUserGroup.get('ConfirmClave');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  onCancelar() {
    this.dialogRef.close(null);
  }

  onGuardar() {

    if (this.esUsuarioAdmin)
      this.guardarAdmin();

    if (this.esUsuarioPropietario)
      this.guardarUsuario();
  }

  guardarAdmin() {

    if (!this.formAdminGroup.valid) {
      this.sharedFunctions.showMessage("Por favor completa todos los datos obligatorios marcados con asterisco" , "Error");
      return false;
    }

    var value = { ...this.entity, ...this.formAdminGroup.getRawValue(), Consorcios: this.consorcios };

    if (value == null) {
      this.sharedFunctions.showMessage("Debe completar todos los campos para continuar con la operación", "Error");
      return false;
    }

    this.buttonEnabled = false;
    this.seguridadService.registerAdmin(value).subscribe(data => {
      this.buttonEnabled = true;
      if (data.Success) {
        var msg = "Se cargaron exitosamente tus datos. Vas a recibir un correo en la casilla de mail que ingresaste previamente y " +
          "a la brevedad se contactará con vos nuestro equipo de ventas. Gracias por elegirnos!";

        this.sharedFunctions.showMessage(msg, "Operación Exitosa!");
        this.dialogRef.close(true);
      } 
      else {
        this.sharedFunctions.showMessage("Ocurrió un error generando el usuario. Vuelva a intentarlo por favor", "Error");
      }
    },
      (err: HttpErrorResponse) => {
        this.buttonEnabled = true;
        this.sharedFunctions.handleError(err, true);
    });
  }

  guardarUsuario() {

    if (!this.formUserGroup.valid) {
      this.sharedFunctions.showMessage("Por favor completa todos los datos obligatorios marcados con asterisco" , "Error");
      return false;
    }

    var value = { ... this.entity, ... this.formUserGroup.getRawValue() };

    if (value == null) {
      this.sharedFunctions.showMessage("Debe completar todos los campos para continuar con la operación", "Error");
      return false;
    }

    if (value.Clave != value.ConfirmClave) {
      this.sharedFunctions.showMessage("La clave ingresada y su confirmación son distintas", "Error");
      return false;
    }

    this.buttonEnabled = false;
    this.seguridadService.registerUser(value).subscribe(data => {
      this.buttonEnabled = true;
      if (data.Success) {
        var msg = "Se cargaron exitosamente los datos de tu usuario. Vas a recibir un correo en la casilla de mail que ingresaste previamente y " +
          "la cual se utilizará para comunicarnos con vos en adelante.";
        if (this.mustWaitUserConfirm)
          msg += "Por el momento aguarda mientras validamos la información que ingresaste para poder utilizar el sistema. Te avisaremos por mail cuando finalicemos.";

        this.sharedFunctions.showMessage(msg, "Operación Exitosa!");
        this.dialogRef.close(true);
      } 
      else {
        this.sharedFunctions.showMessage("Ocurrió un error generando el usuario. Vuelva a intentarlo por favor", "Error");
      }
    },
      (err: HttpErrorResponse) => {
        this.buttonEnabled = true;
        this.sharedFunctions.handleError(err, true);
    });
  }

  onConsorcioAdd() {
    if (this.newConsorcio != null && this.newConsorcio.length > 0) {
      if (this.consorcios == null)
          this.consorcios = [];

      var index = this.consorcios.indexOf(this.newConsorcio);
      if (index < 0)
          this.consorcios.push(this.newConsorcio);
      this.newConsorcio = "";
    }
  }

  onConsorcioDelete(keyword: string) {
    if (keyword != null && keyword.length > 0) {
        if (this.consorcios == null)
            this.consorcios = [];

        var index = this.consorcios.indexOf(keyword);
        if (index >= 0)
            this.consorcios.splice(index, 1);
    }
  }
}